import { render, staticRenderFns } from "./ErrorReports.vue?vue&type=template&id=f6cd6882&scoped=true"
import script from "./ErrorReports.vue?vue&type=script&lang=js"
export * from "./ErrorReports.vue?vue&type=script&lang=js"
import style0 from "./ErrorReports.vue?vue&type=style&index=0&id=f6cd6882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cd6882",
  null
  
)

export default component.exports